import { Column, FlexBox, Text } from '@dixa/lib-shared-habla';
import { isToolUIPart, type UIMessage } from 'ai';

import { useChatScroll } from '../../../../hooks/useChatScroll';
import { MimSidekickToolPartIndicator } from '../mimSidekickToolPartIndicator/mimSidekickToolPartIndicator';

import { MimSidekickMessage } from './components/mimSidekickMessage/mimSidekickMessage';

type MimSidekickMessageListProps = {
  messages: UIMessage[];
};

export const MimSidekickMessageList = ({
  messages,
}: MimSidekickMessageListProps): JSX.Element => {
  const containerRef = useChatScroll(messages);

  if (messages.length === 0) {
    return (
      <Column.Row scrollable>
        <FlexBox alignItems="center" justifyContent="center" height="100%">
          <Text.Paragraph subdued>Ask me about Dixa.</Text.Paragraph>
        </FlexBox>
      </Column.Row>
    );
  }

  return (
    <Column.Row ref={containerRef} scrollable>
      <FlexBox flexDirection="column" gap="200">
        {messages.map((message) => (
          <FlexBox key={message.id} flexDirection="column" gap="100">
            {message.parts.map((part, index) => {
              if (part.type === 'text') {
                return (
                  <MimSidekickMessage
                    key={`${message.id}-${index}`}
                    role={message.role}
                    text={part.text}
                  />
                );
              }
              if (isToolUIPart(part)) {
                return (
                  <MimSidekickToolPartIndicator
                    key={`${message.id}-${index}`}
                    part={part}
                  />
                );
              }
              return null;
            })}
          </FlexBox>
        ))}
      </FlexBox>
    </Column.Row>
  );
};
